import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Messages } from 'src/app/shared/messages/messages';
import { CampaignTab, EconomicalGroupDetailModel } from 'src/app/shared/models/economical-group-detail.model';
import { EconomicalGroupModel } from 'src/app/shared/models/economical-group.model';
import { ErrorService } from 'src/app/shared/service/error.service';
import { LoadingService } from 'src/app/shared/service/loading.service';
import { EconomicalGroupService } from '../services/economical-group.service';

@Component({
  selector: 'app-rate-data-table-modal',
  templateUrl: './rate-data-table-modal.component.html',
  styleUrl: './rate-data-table-modal.component.scss',
  standalone: false
})
export class RateDataTableModalComponent  implements OnInit {
  economicGroupDetail: EconomicalGroupDetailModel = new EconomicalGroupDetailModel();
  isLoading = false;

  campaignTabs: CampaignTab[] = [];
  displayedColumns: string[] = ['bandeira', 'debito', 'credito', 'parcelamentoAte6x', 'parcelamentoMais6x', 'crediario'];
  anticipationFeesDisplayedColumns: string[] = ['maxAnnualBilling', 'suggestedAutoPrepayment'];

  constructor(
    public dialogRef: MatDialogRef<RateDataTableModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EconomicalGroupModel,
    private readonly loadingService: LoadingService,
    private readonly groupService: EconomicalGroupService,
    private readonly errorService: ErrorService
  ) { }

  ngOnInit(): void {
    void this.initData();
  }

  private async initData(): Promise<void> {
    await this.getDetailsGroup(this.data);
    this.loadAnticipationFees();
  }

  loadAnticipationFees(): void {
    this.campaignTabs = [];
    this.isLoading = true;

    if (this.economicGroupDetail?.campaigns?.length > 0) {
      this.economicGroupDetail.campaigns.forEach(campaign => {
        this.campaignTabs.push({
            description: campaign.description,
            mdrRateDataSource: campaign.mdrRates,
            mdrFlexRateDataSource: campaign.mdrFlexRates,
            hasMdrRate: campaign.mdrRates?.length > 0,
            hasMdrFlexRate: campaign.mdrFlexRates?.length > 0,
            mdrWithPrepayment: campaign.mdrWithPrepayment,
            autoPrepayment: campaign.autoPrepayment,
            availableTechnologies: campaign.availableTechnologies
          });
      });
    }
    this.isLoading = false;
  }

  async getDetailsGroup(group: EconomicalGroupModel): Promise<void> {
    this.isLoading = true;
    this.loadingService.show();
    try {
      const response = await this.groupService
        .getDetailsGroup(group.idEconomicGroup, group.serviceContract)
        .toPromise();
      this.economicGroupDetail = response;
      this.economicGroupDetail.idEconomicGroup = group.idEconomicGroup;
    } catch (err) {
      this.errorService.handleXHRError(err as HttpErrorResponse, Messages.SEARCH_ERROR);
    } finally {
      this.isLoading = false;
      this.loadingService.hide();
    }
  }

  getBrandLogo(bandeira: string): string {
    const logos: { [key: string]: string } = {
      'Visa': 'assets/img/flags/VISA.png',
      'Mastercard': 'assets/img/flags/MASTER.png',
      'Elo': 'assets/img/flags/ELO.png',
      'Cabal': 'assets/img/flags/CABAL.png',
      'Amex': 'assets/img/flags/AMEX.png'
    };
    return logos[bandeira] || '';
  }

  close(): void {
    this.dialogRef.close();
  }
}
